<template>
  <div class="typeform-page">
    <!-- Header -->
    <b-card no-body class="">
      <b-card-body class="py-2">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center">
            <div class="tf-icon mr-1">
              <i class="fas fa-poll-h"></i>
            </div>
            <div>
              <div class="tf-title">{{ msg('Typeform Leads') }}</div>
              <div class="tf-subtitle">{{ msg('Browse submissions by form') }}</div>
            </div>
          </div>

          <div class="d-flex align-items-center mt-1 mt-md-0">
            <b-button
                v-if="selectedFormId !== null"
                variant="outline-primary"
                class="tf-secondary-btn mr-1"
                @click="openNewForm()"
            >
              <i class="fas fa-plus mr-50"></i> {{ msg('Fill new form') }}
            </b-button>

            <b-button variant="primary" class="tf-primary-btn" @click="refresh()">
              <i class="fas fa-sync-alt mr-50"></i> {{ msg('Reload') }}
            </b-button>
          </div>

        </div>
      </b-card-body>
    </b-card>

    <!-- Tabs (formId) -->
    <b-card no-body class="">
      <b-card-body class="">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <div class="tf-tabs-wrap">
            <b-nav pills class="tf-tabs">
              <b-nav-item
                  v-for="t in tabsWithAll"
                  :key="t.key"
                  :active="selectedFormId === t.id"
                  @click="selectForm(t.id)"
                  :class="{ 'tf-tab-divider': t.isAll }"
              >
                <span class="tf-tab-text">{{ t.label }}</span>
              </b-nav-item>
            </b-nav>
          </div>


          <div class="d-flex align-items-center mt-1 mt-md-0 flex-wrap">
            <div class="mr-1 " style="min-width:260px">
              <label>{{ msg('Status') }}</label>
              <v-select
                  v-model="filter.in.status"
                  :options="statusOptions"
                  class="w-100"
                  label="text"
                  :reduce="(status) => status.value"
                  multiple
              />
            </div>

            <div class="mr-1" style="min-width:260px">
              <label>{{ msg('Source') }}</label>
              <v-select
                  v-model="filter.in.source"
                  :options="[
                { value: 'CRM', text: msg('CRM') },
                { value: 'typeform', text: msg('WEBSITE') },
              ]" class="w-100"
                  label="text"
                  :reduce="(status) => status.value"
                  multiple
              />
            </div>

            <div class="tf-tool tf-search">
              <label class="tf-label mb-25">{{ msg('Search') }}</label>
              <b-input-group class="tf-search-group">
                <b-form-input
                    v-model="search"
                    :placeholder="msg('Name, email, token...')"
                    @keyup.enter="refresh()"
                />
                <b-input-group-append>
                  <b-button variant="outline-primary" @click="refresh()">
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Content -->
    <b-card no-body class="tf-content-card">
      <b-card-body>
        <div v-if="loading" class="text-center my-4">
          <b-spinner class="align-middle mx-1"></b-spinner>
          <strong>{{ msg('Loading') }}...</strong>
        </div>

        <div v-else>
          <b-row>
            <b-col
                v-for="item in items"
                :key="item.id"
                cols="12"
                md="6"
                lg="4"
                class="mb-2"
            >
              <b-card class="tf-lead-card" @click="openDetails(item)">
                <div class="d-flex align-items-start justify-content-between">
                  <div class="tf-lead-main">
                    <div class="tf-lead-name">
                      {{ getDisplayName(item) }}
                    </div>
                    <div class="tf-lead-meta">
                      <!--                      <span class="tf-pill">
                                              <i class="fas fa-layer-group mr-50"></i>    {{ item.formId || (item.definition && item.definition.id) || '-' }}  </span>-->


                      <div class="tf-modal-pill">
                        <i class="fas fa-network-wired "></i>
                        <span class="ml-50">{{ item.source === 'typeform' ? 'WEBSITE' : 'CRM' }}</span>
                      </div>

                      <span class="tf-pill">
                        <i class="far fa-clock mr-50"></i>    {{ formatDate(item.submittedAt) }}  </span>
                      <span
                          class="tf-pill tf-pill-status"
                          :class="statusPillClass(item && item.status)"
                      >
    <i class="fas fa-flag mr-50"></i>
    {{ statusLabel(item && item.status) }}
  </span>
                    </div>

                  </div>

                  <div class="tf-lead-actions">
                    <b-button
                        size="sm"
                        variant="link"
                        class="tf-del-btn"
                        @click.stop="askDelete(item)"
                        v-b-tooltip.hover
                        :title="msg('Delete')"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>

                    <div class="tf-lead-badge">
                      <i class="fas fa-chevron-right"></i>
                    </div>
                  </div>
                </div>

                <div class="tf-lead-details mt-1">
                  <div class="tf-kv" v-if="getEmail(item)">
                    <div class="tf-k">{{ msg('Email') }}</div>
                    <div class="tf-v">{{ getEmail(item) }}</div>
                  </div>

                  <div class="tf-kv" v-if="getPhone(item)">
                    <div class="tf-k">{{ msg('Phone') }}</div>
                    <div class="tf-v">{{ getPhone(item) }}</div>
                  </div>

                  <div class="tf-kv" v-if="getCompany(item)">
                    <div class="tf-k">{{ msg('Company') }}</div>
                    <div class="tf-v">{{ getCompany(item) }}</div>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <div v-if="items.length === 0" class="tf-empty">
            <div class="tf-empty-icon"><i class="far fa-folder-open"></i></div>
            <div class="tf-empty-title">{{ msg('No submissions found') }}</div>
            <div class="tf-empty-sub">{{ msg('Try a different form tab or search term') }}</div>
          </div>

          <!-- Pagination -->
          <div class="d-flex align-items-center justify-content-center mt-2 flex-wrap">
            <b-pagination
                v-model="page.currentPage"
                :total-rows="page.total"
                :per-page="page.amount"
                first-number
                last-number
                @input="refresh"
                class="tf-pagination"
            />
            <div class="ml-2 tf-total">
              <strong>{{ msg('Total') }}</strong> {{ page.total }}
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Details Modal -->
    <b-modal
        v-model="dialogs.details"
        size="lg"
        centered
        hide-footer
        no-close-on-backdrop
        body-class="tf-modal-body"
        content-class="tf-modal-content"
        dialog-class="tf-modal-dialog"
    >
      <template #modal-title>
        <div class="tf-modal-titlebar">
          <div class="d-flex align-items-center">
            <div class="tf-modal-icon mr-1"><i class="fas fa-clipboard-list"></i></div>
            <div>
              <div class="tf-modal-title">{{ getDisplayName(selectedItem) }}</div>
              <div class="tf-modal-sub">
                {{
                  (selectedItem && selectedItem.definition && selectedItem.definition.title) || msg('Form Submission')
                }}
              </div>
            </div>
          </div>

        </div>
      </template>


      <transition name="tf-pop">
        <div v-if="selectedItem" class="tf-modal-wrap">
          <div class="tf-modal-top">


            <div class="tf-modal-pill">
              <i class="far fa-calendar-alt mr-50"></i>
              {{ msg('Submitted') }}:
              <span class="ml-50">{{ formatDate(selectedItem.submittedAt) }}</span>
            </div>
            <div class="tf-modal-pill">
              <i class="fas fa-network-wired mr-50"></i>
              {{ msg('Source') }}:
              <span class="ml-50">{{ selectedItem.source === 'typeform' ? 'WEBSITE' : 'CRM' }}</span>
            </div>

            <span
                class="tf-pill tf-pill-status"
                :class="statusPillClass(selectedItem && selectedItem.status)"
            ><i class="fas fa-flag mr-50"></i>{{ statusLabel(selectedItem && selectedItem.status) }}  </span>

            <!-- status selector INLINE -->
            <div class="tf-status-inline" v-if="selectedItem">
              <v-select
                  v-model="statusModel"
                  :options="statusOptions"
                  label="text"
                  :reduce="o => o.value"
                  :clearable="false"
                  class="tf-select tf-status-select tf-status-inline-select"
                  @input="onStatusChanged"
              />
            </div>
          </div>


          <div class="tf-qa">
            <div
                v-for="qa in buildQAs(selectedItem)"
                :key="qa.key"
                class="tf-qa-row"
            >
              <div class="tf-q">
                <i class="far fa-question-circle mr-50"></i>
                {{ qa.question }}
              </div>
              <div class="tf-a">
                <span v-if="qa.answer && qa.answer !== ''">{{ qa.answer }}</span>
                <span v-else class="text-muted">-</span>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-2">
            <b-button
                variant="outline-primary"
                class="mr-1"
                :disabled="!canConvertLead"
                @click="openConvertConfirm()"
            >
              <i class="fas fa-random mr-50"></i>
              {{ msg('Convert lead') }}
            </b-button>


            <b-button variant="outline-secondary" @click="dialogs.details=false">
              {{ msg('Close') }}
            </b-button>
          </div>

        </div>
      </transition>
    </b-modal>

    <b-modal
        v-model="dialogs.convertConfirm"
        centered
        :title="msg('Confirm Action')"
        :ok-title="msg('Yes, convert')"
        :cancel-title="msg('Cancel')"
        ok-variant="primary"
        cancel-variant="secondary"
        @ok="confirmConvertLead"
    >
      <div class="py-1">
        {{ msg('Convert this lead to a branch and user?') }}
      </div>
    </b-modal>

    <b-modal
        v-model="dialogs.newForm"
        size="lg"
        centered
        hide-footer
        no-close-on-backdrop
        body-class="tf-modal-body"
        content-class="tf-modal-content"
        dialog-class="tf-modal-dialog"
    >
      <template #modal-title>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <div class="tf-modal-icon mr-1"><i class="fas fa-edit"></i></div>
            <div>
              <div class="tf-modal-title">{{ msg('New submission') }}</div>
              <div class="tf-modal-sub">
                {{ (selectedFormTitle || selectedFormId) }}
              </div>
            </div>
          </div>

        </div>
      </template>
      <div class="d-flex align-items-start">
        <div>
          <label class="tf-label mb-25">{{ msg('Status') }}</label>
          <v-select
              v-model="newFormStatus"
              :options="statusOptions"
              label="text"
              :reduce="o => o.value"
              :clearable="false"
              class="tf-select tf-status-select"
          />
        </div>

      </div>

      <div v-if="newFormDefinition" class="tf-newform">
        <div
            v-for="f in newFormDefinition.fields"
            :key="f.id"
            class="tf-newform-row"
        >
          <label class="tf-newform-label">
            {{ cleanTitle(f.title || f.id) }}
          </label>

          <!-- short_text, long_text -->
          <b-form-input
              v-if="isTextField(f)"
              v-model="newFormModel[f.id]"
              :placeholder="cleanTitle(f.title || f.id)"
          />

          <!-- email -->
          <b-form-input
              v-else-if="f.type === 'email'"
              type="email"
              v-model="newFormModel[f.id]"
              :placeholder="msg('Email')"
          />

          <!-- phone -->
          <b-form-input
              v-else-if="f.type === 'phone_number'"
              v-model="newFormModel[f.id]"
              :placeholder="msg('Phone')"
          />

          <!-- number -->
          <b-form-input
              v-else-if="f.type === 'number'"
              type="number"
              v-model="newFormModel[f.id]"
              :placeholder="msg('Number')"
          />

          <!-- yes_no -->
          <v-select
              v-else-if="f.type === 'yes_no'"
              v-model="newFormModel[f.id]"
              :options="yesNoOptions"
              label="text"
              :reduce="o => o.value"
              :clearable="false"
              class="tf-select"
          />

          <!-- dropdown -->
          <v-select
              v-else-if="f.type === 'dropdown'"
              v-model="newFormModel[f.id]"
              :options="dropdownOptions(f)"
              label="text"
              :reduce="o => o.value"
              :clearable="true"
              class="tf-select"
          />

          <!-- fallback -->
          <b-form-input
              v-else
              v-model="newFormModel[f.id]"
              :placeholder="cleanTitle(f.title || f.id)"
          />
        </div>

        <div class="d-flex justify-content-end mt-2">
          <b-button variant="outline-secondary" class="mr-1" @click="resetNewForm()">
            {{ msg('Reset') }}
          </b-button>
          <b-button variant="primary" @click="saveNewForm()">
            <i class="fas fa-save mr-50"></i> {{ msg('Save') }}
          </b-button>
        </div>
      </div>

      <div v-else class="py-2 text-muted">
        {{ msg('No form definition found for the selected tab.') }}
      </div>
    </b-modal>

    <b-modal
        v-model="dialogs.confirmDelete"
        centered
        :title="msg('Confirm Action')"
        :ok-title="msg('Delete')"
        :cancel-title="msg('Cancel')"
        ok-variant="danger"
        cancel-variant="secondary"
        @ok="confirmDelete"
    >
      <div class="py-1">
        {{ msg('Are you sure you want to delete this submission?') }}
      </div>
    </b-modal>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'TypeformLeads',
  data() {
    return {
      allFormTitles: {},     // master titles
      allFormTabs: [],       // master tabs
      masterFormTabs: [],
      masterFormTitles: {},
      masterFormDefinitions: {}, // { [formId]: definition }

      loading: true,
      formTitles: {}, // { [formId]: title }
      convertCandidateId: null,
      converting: false, // optional

      // tabs
      formTabs: [],
      selectedFormId: null,
      totalFormsCount: 0,

      // list
      items: [],
      search: '',
      filter: {
        like: {search: ''},
        eq: {},
        lte: {},
        gte: {},
        in: {status: []}
      },
      sort: {
        by: 'creationDate',
        desc: true,
        direction: 'desc'
      },

      dialogs: {
        details: false,
        confirmDelete: false,
        newForm: false,
        convertConfirm: false   // ✅ add this
      },

      newFormStatus: 'NEW',

      newFormModel: {},

      yesNoOptions: [
        {value: true, text: this.msg ? this.msg('Yes') : 'Yes'},
        {value: false, text: this.msg ? this.msg('No') : 'No'}
      ],

      page: {
        amount: 12,
        currentPage: 1,
        total: 0
      },
      listeners: {
        refresh: () => {
        }
      },

      selectedItem: null,

// delete
      deleteCandidate: null,

// status
      statusModel: null,
      statusOptions: [
        {value: 'NEW', text: ('New')},
        {value: 'INPROGRESS', text: ('In Progress')},
        {value: 'DONE', text: ('Done')},
        {value: 'REJECTED', text: ('Rejected')}
      ],
    }
  },
  computed: {
    ...mapGetters('translator', ['msg']),
    canConvertLead() {
      if (!this.selectedItem ||
          !this.selectedItem.definition ||
          !this.selectedItem.definition.fields) {
        return false
      }

      const fields = this.selectedItem.definition.fields

      return fields.some(f => {
        if (!f || !f.title) return false
        const title = String(f.title).toLowerCase()

        return (
            title.includes('first name') ||
            title.includes('firstname') ||
            title.includes('vorname') // german support
        )
      })
    }
,
    selectedFormTitle() {
      if (!this.selectedFormId) return ''
      return (this.formTitles && this.formTitles[this.selectedFormId]) ? this.formTitles[this.selectedFormId] : ''
    },

    newFormDefinition() {
      // Find a definition for the selected form from currently loaded items (best effort)
      if (!this.selectedFormId) return null
      const hit = (this.items || []).find(i => (i.formId || (i.definition && i.definition.id)) === this.selectedFormId)
      return hit && hit.definition ? hit.definition : null
    },

    selectedFormDefinition() {
      if (!this.selectedFormId) return null
      return this.masterFormDefinitions
          ? this.masterFormDefinitions[this.selectedFormId]
          : null
    },
    tabsWithAll() {
      const arr = []
      arr.push({key: 'all', id: null, label: this.msg('All'), isAll: true})
      for (let i = 0; i < (this.formTabs || []).length; i++) {
        const fid = this.formTabs[i]
        arr.push({
          key: fid,
          id: fid,
          label: (this.formTitles && this.formTitles[fid]) ? this.formTitles[fid] : fid,
          isAll: false
        })
      }
      return arr
    }
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh()
      }
    }
  },
  created() {
    let $this = this;

    this.refresh()
    this.$root.$on('crm::branch-updated', (this.listeners.refresh = () => {
      $this.refresh()
    }))
  },
  methods: {
    ...mapActions('typeform', ['getAll', 'deleteOne', 'updateTypeForm', 'createTypeForm','convertLead']),

    openConvertConfirm() {
      if (!this.selectedItem || !this.selectedItem.id) return
      this.convertCandidateId = this.selectedItem.id
      this.dialogs.convertConfirm = true
    },

    confirmConvertLead() {
      const id = this.convertCandidateId
      if (!id) return

      this.converting = true

      this.convertLead( id )
          .then(() => {
            this.dialogs.convertConfirm = false
            this.convertCandidateId = null

            // optional: close details modal too
            this.dialogs.details = false

            // refresh list so status changes etc
            this.refresh()
          })
          .catch(() => {
            // optional toast
          })
          .finally(() => {
            this.converting = false
          })
    },

    openNewForm() {
      if (!this.selectedFormId) return

      // must have definition to render fields
      if (!this.selectedFormDefinition || !this.selectedFormDefinition.fields) {
        // optional toast:
        // this.$bvToast.toast(this.msg('No definition found for this form yet.'), { variant: 'warning' })
        return
      }

      this.resetNewForm()
      this.newFormStatus = 'NEW'
      this.dialogs.newForm = true
    },


    resetNewForm() {
      const def = this.newFormDefinition
      const model = {}
      if (def && def.fields) {
        def.fields.forEach(f => {
          const fid = f.id || f._id
          model[fid] = null
        })
      }
      this.newFormModel = model
    }
    ,

    isTextField(f) {
      const t = (f && f.type) ? String(f.type) : ''
      return t === 'short_text' || t === 'long_text' || t === 'text'
    },

    cleanTitle(title) {
      // remove markdown-ish underscores _like this_
      if (!title) return ''
      return String(title).replace(/_/g, '').trim()
    },

    dropdownOptions(f) {
      // if your backend stores choices in fieldDefinition.choices - use it
      const choices = (f && f.choices) ? f.choices : []
      return choices.map(c => ({
        value: c.label || c.id,
        text: c.label || c.id
      }))
    },

    saveNewForm() {
      if (!this.selectedFormId) return

      // Prefer cached definition (master), fallback to what you found in items
      const def = this.selectedFormDefinition || this.newFormDefinition
      if (!def || !def.fields) return

      const nowIso = new Date().toISOString()

      const getFieldId = (f) => f.id || f._id
      const getFormId = (d) => d.id || d._id || this.selectedFormId

      // 1) Build answers (webhook-like)
      const answers = (def.fields || [])
          .map(f => {
            const fid = getFieldId(f)
            const raw = this.newFormModel[fid]

            if (raw === null || raw === undefined || raw === '') return null

            const baseField = {
              _id: fid,             // matches your Mongo sample
              id: fid,              // harmless extra if backend expects "id"
              ref: f.ref,
              type: f.type
            }

            // Map field.type -> webhook answer.type + value field
            if (f.type === 'email') {
              return {type: 'email', field: baseField, email: String(raw)}
            }
            if (f.type === 'phone_number') {
              return {type: 'phone_number', field: baseField, phoneNumber: String(raw)}
            }
            if (f.type === 'number') {
              return {type: 'number', field: baseField, numberValue: Number(raw)}
            }
            if (f.type === 'yes_no') {
              return {type: 'boolean', field: baseField, booleanValue: !!raw}
            }
            if (f.type === 'dropdown' || f.type === 'multiple_choice') {
              return {type: 'choice', field: baseField, choice: {label: String(raw)}}
            }

            // default text
            return {type: 'text', field: baseField, text: String(raw)}
          })
          .filter(Boolean)

      // 2) Build definition (webhook-like) and ATTACH IT to payload
      const definitionToSend = {
        _id: getFormId(def),     // matches your Mongo sample
        id: getFormId(def),      // harmless extra
        title: def.title || this.selectedFormTitle || this.selectedFormId,
        fields: (def.fields || []).map(f => ({
          _id: getFieldId(f),
          id: getFieldId(f),
          ref: f.ref,
          type: f.type,
          title: f.title,
          allowOtherChoice: !!f.allowOtherChoice,
          // keep choices if you have them
          choices: f.choices || undefined
        }))
      }

      // 3) Final payload (this is what your backend currently misses)
      const payload = {
        formId: this.selectedFormId,
        buid: this.buid,                 // if you actually have it; otherwise remove
        landedAt: nowIso,
        submittedAt: nowIso,
        source: 'CRM',
        status: this.newFormStatus,
        definition: definitionToSend,    // ✅ THIS IS THE KEY
        answers
      }

      // Debug once (optional)
      // console.log('CREATE TYPEFORM payload:', JSON.stringify(payload, null, 2))

      this.createTypeForm({form: payload})
          .then(() => {
            this.dialogs.newForm = false
            this.refresh()
          })
          .catch(() => {
            // optional toast
          })
    },
    convertLeadToBranch(id) {
      this.convertLead({id}).then(() => {
        this.dialogs.details = false
        this.selectedItem = null
        this.refresh()
      }).catch(() => {
        // optional: show toast
      })
    }
    , selectForm(fid) {
      this.selectedFormId = fid
      this.filter.eq.formId = fid          // ✅ same style as your other pages
      this.page.currentPage = 1
      this.refresh()
    },


    onPerPageChange() {
      this.page.currentPage = 1
      this.refresh()
    },


    refresh() {
      let $this = this
      this.loading = true;
      this.sort = {
        by: 'creationDate',
        desc: true,
        direction: 'desc'
      },
          this.getAll({
            page: $this.page.currentPage,
            amount: $this.page.amount,
            filter: $this.filter,
            sortcolumn: $this.sort.by,
            sortby: $this.sort.direction,
          }).then(this.onRetrieve, (error) => $this.error = error)

    },
    onRetrieve(data) {
      this.page = {
        amount: data['Amount'] || this.page.amount,
        total: data['Total'] || 0,
        currentPage: data['Page'] || this.page.currentPage
      }

      this.items = data['Typeforms'] || []

      const titlesMap = this.extractFormTitlesFromItems(this.items)
      const idsList = this.extractFormIdsFromItems(this.items)

      // ✅ Only update master list when we're on "All"
      if (this.selectedFormId === null) {
        this.masterFormTitles = titlesMap
        this.masterFormTabs = idsList
      }

      // ✅ Always render tabs from master (never collapse)
      this.formTitles = this.masterFormTitles
      this.formTabs = this.masterFormTabs

      // ✅ Edge case: first load (master empty) – use current response
      if (!this.formTabs || this.formTabs.length === 0) {
        this.formTitles = titlesMap
        this.formTabs = idsList
        this.masterFormTitles = titlesMap
        this.masterFormTabs = idsList
      }
      const defsMap = this.extractFormDefinitionsFromItems(this.items)

      if (this.selectedFormId === null) {
        this.masterFormDefinitions = {...this.masterFormDefinitions, ...defsMap}
      }

// always use master cache (never collapse)
      if (!this.masterFormDefinitions) this.masterFormDefinitions = {}
      this.loading = false
    },

    extractFormDefinitionsFromItems(items) {
      const map = {}
      ;(items || []).forEach(i => {
        const fid = i.formId || (i.definition && i.definition.id)
        if (!fid) return
        if (i.definition && !map[fid]) {
          map[fid] = i.definition // keep full object: id/title/fields
        }
      })
      return map
    },


    extractFormTitlesFromItems(items) {
      const map = {}
      items.forEach(i => {
        const fid = i.formId || (i.definition && i.definition.id)
        if (!fid) return
        const title = (i.definition && i.definition.title) ? String(i.definition.title).trim() : ''
        if (title && !map[fid]) map[fid] = title
      })
      return map
    },

    extractFormIdsFromItems(items) {
      const set = {}
      items.forEach(i => {
        const fid = i.formId || (i.definition && i.definition.id)
        if (fid) set[fid] = true
      })
      return Object.keys(set)
    },

    openDetails(item) {
      this.selectedItem = item
      this.statusModel = (item && item.status) ? item.status : 'NEW'
      this.dialogs.details = true
    },

    // --------- nice card fields (best effort) ----------
    getDisplayName(item) {
      const first = this.findAnswerByTitle(item, ['first name', 'firstname', 'vorname'])
      const last = this.findAnswerByTitle(item, ['last name', 'lastname', 'nachname'])
      const email = this.getEmail(item)

      const full = [first, last].filter(Boolean).join(' ').trim()
      if (full) return full
      if (email) return email
      return this.msg('Lead')
    },
    askDelete(item) {
      this.deleteCandidate = item
      this.dialogs.confirmDelete = true
    },

    confirmDelete() {
      if (!this.deleteCandidate || !this.deleteCandidate.id) return

      const id = this.deleteCandidate.id
      this.deleteCandidate = null

      // call backend, then refresh list
      this.deleteOne({id}).then(() => {
        // if modal was open for this item - close it
        if (this.selectedItem && this.selectedItem.id === id) {
          this.dialogs.details = false
          this.selectedItem = null
        }
        this.refresh()
      }).catch(() => {
        // optional: show toast
      })
    },

    onStatusChanged(newStatus) {
      if (!this.selectedItem || !this.selectedItem.id) return
      const id = this.selectedItem.id

      this.selectedItem.status = newStatus


      this.updateTypeForm({form: this.selectedItem}).then(() => {
        // update UI immediately
        this.selectedItem.status = newStatus

        // also update the card list item
        const idx = this.items.findIndex(x => x && x.id === id)
        if (idx !== -1) this.items[idx].status = newStatus
      }).catch(() => {
        // rollback if needed
        this.statusModel = this.selectedItem.status || 'NEW'
      })
    },

    statusLabel(status) {
      const s = status || 'NEW'
      const hit = this.statusOptions.find(x => x.value === s)
      return hit ? hit.text : s
    },

    statusPillClass(status) {
      const s = status || 'NEW'
      return {
        'is-new': s === 'NEW',
        'is-inProgress': s === 'INPROGRESS',
        'is-done': s === 'DONE',
        'is-rejected': s === 'REJECTED',
      }
    },

    getEmail(item) {
      const v = this.findAnswerByType(item, 'email') || this.findAnswerByTitle(item, ['email'])
      return v || ''
    },

    getPhone(item) {
      const v = this.findAnswerByType(item, 'phone_number') || this.findAnswerByTitle(item, ['phone'])
      return v || ''
    },

    getCompany(item) {
      return this.findAnswerByTitle(item, ['company', 'firma']) || ''
    },

    findAnswerByType(item, type) {
      if (!item || !item.answers) return ''
      const a = item.answers.find(x => x && x.type === type)
      if (!a) return ''
      return (a.email || a.phoneNumber || a.text || (a.choice && a.choice.label) || (a.booleanValue === true ? 'Yes' : (a.booleanValue === false ? 'No' : '')) || '')
    },

    findAnswerByTitle(item, keywords) {
      if (!item || !item.answers || !item.definition || !item.definition.fields) return ''
      const fields = item.definition.fields

      // join by field.id -> field.title
      for (let i = 0; i < item.answers.length; i++) {
        const ans = item.answers[i]
        if (!ans || !ans.field || !ans.field.id) continue

        const def = fields.find(f => f && f.id === ans.field.id)
        const title = (def && def.title ? String(def.title).toLowerCase() : '')
        if (!title) continue

        const hit = keywords.some(k => title.includes(String(k).toLowerCase()))
        if (!hit) continue

        return (ans.email || ans.phoneNumber || ans.text || (ans.choice && ans.choice.label) || (ans.booleanValue === true ? 'Yes' : (ans.booleanValue === false ? 'No' : '')) || '')
      }
      return ''
    },

    // --------- modal Q/A ----------
    buildQAs(item) {
      if (!item || !item.definition || !item.definition.fields) return []

      const fields = item.definition.fields
      const answers = item.answers || []

      const answerByFieldId = {}
      answers.forEach(a => {
        if (a && a.field && a.field.id) {
          answerByFieldId[a.field.id] = (a.email || a.phoneNumber || a.text || (a.choice && a.choice.label) ||
              (a.booleanValue === true ? 'Yes' : (a.booleanValue === false ? 'No' : '')) || '')
        }
      })

      return fields.map(f => ({
        key: f.id,
        question: f.title || f.id,
        answer: answerByFieldId[f.id] || ''
      }))
    },

    formatDate(val) {
      if (!val) return '-'
      // If you already use moment globally, keep it:
      if (this.$moment) {
        return this.$moment(val).format('DD.MM.YYYY HH:mm')
      }
      return String(val)
    }
  }
}
</script>

<style scoped>
/* =========================================================
   Typeform Leads - Clean merged theme (no duplicates)
   More contrast + nicer tabs + better background separation
   ========================================================= */

.typeform-page {
  padding-bottom: 20px;
  /* subtle page background to separate cards from page */
  background: radial-gradient(1200px 400px at 20% 0%, rgba(0, 184, 148, .06), transparent 60%),
  radial-gradient(1000px 380px at 90% 10%, rgba(115, 103, 240, .06), transparent 55%);
  border-radius: 18px;
}

/* ---------- Cards general look ---------- */
.tf-header-card,
.tf-tabs-card,
.tf-content-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, .06);
  box-shadow: 0 10px 26px rgba(0, 0, 0, .06);
  //background: rgba(249, 16, 16, 0.92);
  backdrop-filter: blur(6px);
}

.tf-header-card {
  margin-bottom: 14px;
}

.tf-tabs-card {
  margin-bottom: 14px;
}

.tf-content-card {
}

/* Header */
.tf-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(115, 103, 240, .14);
  color: #7367f0;
}

.tf-title {
  font-weight: 900;
  font-size: 16px;
  line-height: 1.1;
  letter-spacing: .2px;
}

.tf-subtitle {
  font-size: 12px;
  opacity: .78;
}

.tf-refresh {
  opacity: .8;
}

.tf-refresh:hover {
  opacity: 1;
}

.tf-primary-btn {
  border-radius: 12px;
}

/* ---------- Tabs (make them pop & not blend) ---------- */
.tf-tabs-wrap {
  max-width: 100%;
  overflow: auto;
  padding-bottom: 2px;
}

.tf-tabs {
  flex-wrap: nowrap;
  padding: 2px;
  border-radius: 999px;
  background: rgba(0, 0, 0, .03);
  border: 1px solid rgba(0, 0, 0, .05);
}

.tf-tabs :deep(.nav-link) {
  border-radius: 999px !important;
  padding: 8px 14px;
  margin-right: 6px;
  font-weight: 800;
  font-size: 12px;
  background: rgba(255, 255, 255, .85);
  border: 1px solid rgba(0, 0, 0, .06);
  color: inherit;
  transition: transform .12s ease, box-shadow .12s ease, background .12s ease;
  white-space: nowrap;
}

.tf-tabs :deep(.nav-link:hover) {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, .08);
  background: rgba(255, 255, 255, .95);
}

/* ACTIVE TAB: teal accent */
.tf-tabs :deep(.nav-link.active) {
  background: linear-gradient(180deg, rgba(0, 184, 148, .16), rgba(0, 184, 148, .10)) !important;
  border-color: rgba(0, 184, 148, .35) !important;
  color: #00b894 !important;
  box-shadow: 0 12px 22px rgba(0, 0, 0, .10);
}

.tf-tab-text {
  white-space: nowrap;
}

/* Tools */
.tf-tools {
  gap: 12px;
}

.tf-label {
  font-size: 11px;
  opacity: .75;
}

.tf-select :deep(.vs__dropdown-toggle) {
  border-radius: 12px;
}

.tf-search-group .form-control {
  border-radius: 12px 0 0 12px;
}

.tf-search-group .btn {
  border-radius: 0 12px 12px 0;
}

/* ---------- Lead cards: more contrast + stripe accent ---------- */
.tf-lead-card {
  border-radius: 18px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, .08);
  background: rgba(209, 225, 235, 0.68);
  box-shadow: 0 10px 22px rgba(0, 0, 0, .08);
  transition: transform .16s ease, box-shadow .16s ease, border-color .16s ease;
}

.dark-layout .tf-lead-card {
  border-radius: 18px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, .08);
  background: rgba(61, 77, 118, 0.38);
  box-shadow: 0 10px 22px rgba(0, 0, 0, .08);
  transition: transform .16s ease, box-shadow .16s ease, border-color .16s ease;
}

/* left accent stripe */
.tf-lead-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 7px;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 184, 148, .95), rgba(0, 184, 148, .25));
}

/* subtle top highlight */
.tf-lead-card::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 1px;
  background: rgba(0, 0, 0, .04);
}

.tf-lead-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 34px rgba(0, 0, 0, .14);
  border-color: rgba(0, 184, 148, .30);
}

.tf-lead-card :deep(.card-body) {
  padding-left: 16px; /* space from stripe */
}

.tf-lead-name {
  font-weight: 900;
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: .1px;
}

.tf-lead-meta {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* pills: teal accent for contrast */
.tf-pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(0, 184, 148, .10);
  border: 1px solid rgba(0, 184, 148, .18);
  color: rgba(0, 184, 148, .95);
}

.tf-lead-badge {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .035);
  border: 1px solid rgba(0, 0, 0, .06);
}

/* Details blocks inside card (more readable) */
.tf-lead-details {
  display: grid;
  gap: 8px;
  margin-top: 10px;
}

.tf-kv {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 8px;
  padding: 9px 10px;
  border-radius: 14px;
  background: rgba(0, 0, 0, .018);
  border: 1px solid rgba(0, 0, 0, .06);
}

.tf-k {
  font-size: 11px;
  opacity: .75;
}

.tf-v {
  font-size: 12px;
  font-weight: 800;
  word-break: break-word;
}

/* Empty state */
.tf-empty {
  text-align: center;
  padding: 26px 0;
}

.tf-empty-icon {
  font-size: 34px;
  opacity: .5;
  margin-bottom: 8px;
}

.tf-empty-title {
  font-weight: 900;
}

.tf-empty-sub {
  opacity: .75;
  font-size: 12px;
}

/* Pagination */
.tf-pagination :deep(.page-link) {
  border-radius: 10px !important;
}

.tf-total {
  font-size: 12px;
  opacity: .85;
}

/* ---------- Modal: more contrast + teal accent ---------- */
.tf-modal-dialog :deep(.modal-dialog) {
  border-radius: 18px;
}

.tf-modal-content {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, .10);
  box-shadow: 0 18px 50px rgba(0, 0, 0, .18);
}

.tf-modal-body {
  padding: 18px;
  background: rgba(255, 255, 255, .98);
}

.tf-modal-icon {
  width: 38px;
  height: 38px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 184, 148, .12);
  color: #00b894;
}

.tf-modal-title {
  font-weight: 900;
  font-size: 15px;
  line-height: 1.2;
}

.tf-modal-sub {
  font-size: 12px;
  opacity: .78;
}

.tf-modal-top {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.tf-modal-pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  padding: 9px 11px;
  border-radius: 999px;
  background: rgba(0, 184, 148, .10);
  border: 1px solid rgba(0, 184, 148, .18);
  color: rgba(0, 184, 148, .95);
}

.tf-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/* Q/A blocks */
.tf-qa {
  display: grid;
  gap: 10px;
}

.tf-qa-row {
  border: 1px solid rgba(0, 0, 0, .08);
  border-radius: 16px;
  padding: 12px 12px;
  background: rgba(0, 0, 0, .012);
  position: relative;
  overflow: hidden;
}

.tf-qa-row::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 184, 148, .95), rgba(0, 184, 148, .25));
}

.tf-q {
  font-weight: 900;
  font-size: 12px;
  margin-bottom: 6px;
  padding-left: 6px;
}

.tf-a {
  font-size: 13px;
  font-weight: 800;
  word-break: break-word;
  padding-left: 6px;
}

/* Animation */
.tf-pop-enter-active, .tf-pop-leave-active {
  transition: all .18s ease;
}

.tf-pop-enter, .tf-pop-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(.99);
}

@media (max-width: 768px) {
  .tf-kv {
    grid-template-columns: 76px 1fr;
  }
}

/* Card actions: delete + chevron */
.tf-lead-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tf-del-btn {
  padding: 0;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ea5455; /* red */
  background: rgba(234, 84, 85, .10);
  border: 1px solid rgba(234, 84, 85, .22);
  transition: transform .12s ease, box-shadow .12s ease, background .12s ease;
}

.tf-del-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(234, 84, 85, .18);
  background: rgba(234, 84, 85, .14);
}

/* Modal title bar layout */
.tf-modal-titlebar {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.tf-modal-status {
  min-width: 210px;
  text-align: right;
}

.tf-status-select :deep(.vs__dropdown-toggle) {
  border-radius: 12px;
}

/* Status pill variants */
.tf-pill-status {
  border: 1px solid rgba(0, 0, 0, .06);
}

.tf-pill-status.is-new {
  background: rgba(255, 159, 67, .14);
  border-color: rgba(255, 159, 67, .28);
  color: rgba(255, 159, 67, 1);
}

.tf-pill-status.is-inProgress {
  background: rgba(0, 207, 232, .14);
  border-color: rgba(0, 207, 232, .28);
  color: rgba(0, 207, 232, 1);
}

.tf-pill-status.is-done {
  background: rgba(40, 199, 111, .14);
  border-color: rgba(40, 199, 111, .28);
  color: rgba(40, 199, 111, 1);
}

.tf-pill-status.is-rejected {
  background: rgba(234, 84, 85, .14);
  border-color: rgba(234, 84, 85, .28);
  color: rgba(234, 84, 85, 1);
}

@media (max-width: 768px) {
  .tf-modal-titlebar {
    flex-direction: column;
    align-items: stretch;
  }

  .tf-modal-status {
    text-align: left;
    min-width: unset;
  }
}

/* modal top row */
.tf-modal-top {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center; /* <-- important */
  margin-bottom: 12px;
}

/* inline select container */
.tf-status-inline {
  display: flex;
  align-items: center;
}

/* make v-select look like a pill button */
.tf-status-inline-select :deep(.vs__dropdown-toggle) {
  border-radius: 999px !important;
  min-height: 34px;
  padding: 0 10px;
  background: rgba(255, 255, 255, .85);
  border: 1px solid rgba(0, 0, 0, .08);
}

/* keep the inside text compact */
.tf-status-inline-select :deep(.vs__selected) {
  font-weight: 800;
  font-size: 12px;
}

/* keep caret aligned */
.tf-status-inline-select :deep(.vs__actions) {
  padding-right: 6px;
}

/* optional: when focusing, highlight teal */
.tf-status-inline-select :deep(.vs--open .vs__dropdown-toggle),
.tf-status-inline-select :deep(.vs__dropdown-toggle:focus-within) {
  border-color: rgba(0, 184, 148, .35) !important;
  box-shadow: 0 10px 22px rgba(0, 0, 0, .10);
}

/* keep all pills in one line */
.tf-tabs {
  display: flex;
  align-items: center;
}

/* separator between All and the rest */
.tf-tab-sep {
  display: inline-block;
  width: 1px;
  height: 24px;
  margin: 0 10px;
  background: rgba(0, 0, 0, .12);
  border-radius: 2px;
  flex: 0 0 auto;
}

/* on dark layout, make separator visible */
.dark-layout .tf-tab-sep {
  background: rgba(255, 255, 255, .18);
}

/* optional: slightly bolder All pill text */
.tf-tab-all :deep(.nav-link) {
  font-weight: 900;
}

/* vertical separator after "All" */
.tf-tabs :deep(li.nav-item.tf-tab-divider) {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid rgba(0, 0, 0, .14);
}

.dark-layout .tf-tabs :deep(li.nav-item.tf-tab-divider) {
  border-right: 1px solid rgba(255, 255, 255, .18);
}

.tf-modal-status--new {
  min-width: 200px;
  text-align: right;
}

@media (max-width: 768px) {
  .tf-modal-status--new {
    text-align: left;
    min-width: unset;
  }
}

</style>
